const CANONICAL_RATING_MAX = 1;
const FIVE_STAR_RATING_MAX = 5;
const PERCENT_RATING_MAX = 100;
/**
 * Card footers treat `rating_score` as 0–1 (`0.96` → `96%`). Stub Discovery
 * documents currently send a 5-star value (`4.8` → `480%`) which also blows
 * the footer layout. Values already on the 0–1 scale pass through.
 */
const readDiscoverCharacterRatingScore = (ratingScore) => {
    if (ratingScore === undefined || ratingScore <= 0) {
        return 0;
    }
    if (ratingScore <= CANONICAL_RATING_MAX) {
        return ratingScore;
    }
    if (ratingScore <= FIVE_STAR_RATING_MAX) {
        return ratingScore / FIVE_STAR_RATING_MAX;
    }
    return Math.min(ratingScore / PERCENT_RATING_MAX, CANONICAL_RATING_MAX);
};
export default readDiscoverCharacterRatingScore;
